import AkFeatureGates from '@atlaskit/feature-gate-js-client';

// Feature gate for Sentry user context tracking
// This allows us to control whether user context is sent to Sentry
export const GATE_NAME = 'admin-hub-sentry-user-context-gate';

/**
 * Checks if Sentry user context tracking is enabled via feature gate
 *
 * @returns boolean indicating if the feature is enabled
 */
export const isSentryUserContextEnabled = () => AkFeatureGates.checkGate(GATE_NAME);
